import { render } from "./AllProductsView.vue?vue&type=template&id=7a0edf82&scoped=true"
import script from "./AllProductsView.vue?vue&type=script&lang=js"
export * from "./AllProductsView.vue?vue&type=script&lang=js"

import "./AllProductsView.vue?vue&type=style&index=0&id=7a0edf82&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a0edf82"]])

export default __exports__